import { render, staticRenderFns } from "./KidsInscrevase.vue?vue&type=template&id=69808972&scoped=true&"
import script from "./KidsInscrevase.vue?vue&type=script&lang=js&"
export * from "./KidsInscrevase.vue?vue&type=script&lang=js&"
import style0 from "./KidsInscrevase.vue?vue&type=style&index=0&id=69808972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69808972",
  null
  
)

export default component.exports